import Box from './Box';
import BoxPrimary from './BoxPrimary';
import BoxSecondary from './BoxSecondary';

Box.Primary = BoxPrimary;
Box.Secondary = BoxSecondary;

export default Box;
